export default function LandingItalyGet({data}) {
  return (
    <>
      <section className="land2-get-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="land2-get-details">
                <h3 className="heading gradiant-color">{data.title}</h3>
                <span>{data.subTitle}</span>
                <p>{data.desc}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
